var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.items.length && !_vm.gold ? _c('div', {
    staticClass: "px-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Item')
    }
  })], 1) : _c('div', [_c('Scroller', {
    staticClass: "text-center",
    attrs: {
      "icon": _vm.$size()
    }
  }, [_c('div', {
    staticClass: "pl-2 pl-md-0"
  }), _vm._l(_vm.items, function (item, i) {
    return _c('div', {
      key: "itemlist-item-".concat(item),
      staticClass: "ml-2 ml-md-4"
    }, [_c('router-link', {
      attrs: {
        "to": "/item/".concat(item)
      }
    }, [_c('v-avatar', {
      attrs: {
        "size": _vm.$size()
      }
    }, [_c('v-img', {
      attrs: {
        "src": _vm.$asset.itemicon.format(item) + '.jpg'
      }
    })], 1)], 1), _vm.amounts[i] ? _c('div', {
      staticClass: "caption",
      staticStyle: {
        "line-height": "1rem"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.amounts[i])
      }
    }) : _vm._e()], 1);
  }), _vm.gold ? _c('div', {
    key: "items-item-key",
    staticClass: "ml-2 ml-md-4"
  }, [_c('v-avatar', {
    attrs: {
      "size": _vm.$size()
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.commonuiatlas.format('GoldIcon') + '.jpg'
    }
  })], 1), _c('div', {
    staticClass: "caption",
    staticStyle: {
      "line-height": "1rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.gold)
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "pl-4"
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }